import style from '../../secondary/PasswordHint/passwordHint.module.scss'

export const PasswordHint = ({ minLength, oneNum, oneSpecialChar, oneUCase }) => {

    return <div className='pass_condition' >
        <ul className={style.password_hints}>
            <li className={minLength ? style.pass_condition : style.fail_condition} ><span /> Minimum of 8 characters </li>
            <li className={oneSpecialChar ? style.pass_condition : style.fail_condition} ><span />One special character </li>
            <li className={oneNum ? style.pass_condition : style.fail_condition} ><span /> One number </li>
            <li className={oneUCase ? style.pass_condition : style.fail_condition} ><span /> One upper case </li>
        </ul>
    </div>
} 